import type { CaseRequestViewPayload } from '../../services/caseRequestViewData';
import ViewRequestAttorneyGeneralCaseDetailsTab from './ViewRequestAttorneyGeneralCaseDetailsTab';
import ViewRequestCaseDetailsTab from './ViewRequestCaseDetailsTab';
import ViewRequestCivilAdviseCaseDetailsTab from './ViewRequestCivilAdviseCaseDetailsTab';
import ViewRequestCivilAppellateCaseDetailsTab from './ViewRequestCivilAppellateCaseDetailsTab';
import ViewRequestCivilLitigationCaseDetailsTab from './ViewRequestCivilLitigationCaseDetailsTab';
import ViewRequestCriminalAppellateCaseDetailsTab from './ViewRequestCriminalAppellateCaseDetailsTab';
import ViewRequestExtraditionMlaCaseDetailsTab from './ViewRequestExtraditionMlaCaseDetailsTab';
import ViewRequestNominationCaseDetailsTab from './ViewRequestNominationCaseDetailsTab';
import ViewRequestPublicPetitionCaseDetailsTab from './ViewRequestPublicPetitionCaseDetailsTab';
import ViewRequestRightToInformationCaseDetailsTab from './ViewRequestRightToInformationCaseDetailsTab';

type Props = {
  payload: CaseRequestViewPayload;
  caseRequestId: string;
  /** Task/Case Details screen — documents are managed on the Documents tab. */
  hideUploadDocumentsStep?: boolean;
};

function CompletionRemarksBlock({ completionRemarks }: { completionRemarks?: string }) {
  if (!completionRemarks) return null;
  return (
    <p style={{ marginBottom: 12 }}>
      <strong>Completion Remarks:</strong> {completionRemarks}
    </p>
  );
}

export default function ViewRequestCaseDetailsRouter({
  payload,
  caseRequestId,
  hideUploadDocumentsStep = false,
}: Props) {
  const completionRemarks = payload.data.completionRemarks;

  switch (payload.flow) {
    case 'criminal':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step1={payload.data.step1}
            step2={payload.data.step2}
            step3={payload.data.step3}
            step4={payload.data.step4}
          />
        </>
      );
    case 'civil-advise':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestCivilAdviseCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step3={payload.data.step3}
            hideUploadDocumentsStep={hideUploadDocumentsStep}
          />
        </>
      );
    case 'civil-appellate':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestCivilAppellateCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step4={payload.data.step4}
          />
        </>
      );
    case 'civil-litigation':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestCivilLitigationCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step4={payload.data.step4}
            hideUploadDocumentsStep={hideUploadDocumentsStep}
          />
        </>
      );
    case 'criminal-appellate':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestCriminalAppellateCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step4={payload.data.step4}
            coverSubmitter={payload.data.coverSubmitter}
          />
        </>
      );
    case 'nomination-requests':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestNominationCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step3={payload.data.step3}
          />
        </>
      );
    case 'extradition-mla':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestExtraditionMlaCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
          />
        </>
      );
    case 'public-petition':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestPublicPetitionCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step4={payload.data.step4}
            hideUploadDocumentsStep={hideUploadDocumentsStep}
          />
        </>
      );
    case 'right-to-information':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestRightToInformationCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step3={payload.data.step3}
            hideUploadDocumentsStep={hideUploadDocumentsStep}
          />
        </>
      );
    case 'attorney-general':
      return (
        <>
          <CompletionRemarksBlock completionRemarks={completionRemarks} />
          <ViewRequestAttorneyGeneralCaseDetailsTab
            caseRequestId={caseRequestId}
            draft={payload.data.draft}
            submittedAt={payload.data.submittedAt}
            step11={payload.data.step11}
            hideUploadDocumentsStep={hideUploadDocumentsStep}
          />
        </>
      );
    default:
      return null;
  }
}
